import styled from "styled-components";
import bg from "assets/images/badges-circle.png";

export const Wrapper = styled.div<{$width?: string; $height?: string}>`
	border-radius: 50%;
	background: url(${bg}) no-repeat center;
	background-size: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	height: ${({$height}) => $height || "100%"};
	width: ${({$width}) => $width || "100%"};
	position: relative;
`;

export const Container = styled.div`
	border-radius: 50%;
	background: ${({theme}) => theme.background.tertiary};
	width: 80%;
	height: 80%;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	color: #18c971;
`;

export const Img = styled.img`
	width: 50%;
	height: 50%;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
`;
